"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Financing = void 0;
var Financing;
(function (Financing) {
    Financing["CASH"] = "cash";
    Financing["LEASING"] = "leasing";
    Financing["LOAN"] = "loan";
})(Financing = exports.Financing || (exports.Financing = {}));
//# sourceMappingURL=financing.js.map